import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

function ClockIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  );
}
function ZapIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  );
}
function CheckIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  );
}
function ShieldIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

const iconMap = { clock: ClockIcon, zap: ZapIcon, check: CheckIcon, shield: ShieldIcon };

export default function TrustBar() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  const stats = [
    { number: '40+', label: t.trustYears, icon: 'clock' },
    { number: '35', label: t.trustMinute, icon: 'zap', suffix: ' MIN' },
    { number: 'FREE', label: t.trustInspections, icon: 'check', isText: true },
    { number: '100%', label: t.trustSatisfaction, icon: 'shield' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="trust-bar" data-testid="trust-bar" ref={ref}>
      <div className="sm-container">
        <div className="trust-bar-grid">
          {stats.map((stat, i) => {
            const Icon = iconMap[stat.icon];
            return (
              <div key={i} className="trust-item reveal-item" style={{ transitionDelay: `${i * 80}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
                <div className="trust-icon"><Icon /></div>
                <div className="trust-number">{stat.number}{stat.suffix || ''}</div>
                <div className="trust-label">{stat.label.split('\n').map((l, j) => <span key={j}>{l}{j === 0 ? <br /> : ''}</span>)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
